<template>
  <div
    v-if="!loading"
    class="cancellation-flow"
  >
    <CancellationReviewDataDialog
      v-if="modals.reviewData"
      id="reviewData"
      :title="title"
      :show="modals.reviewData"
      :organization-id="organizationId"
      :is-trial="isTrial"
      @toggleDialog="toggleDialog"
      @next="next"
    />

    <CancellationFirstOfferDialog
      id="firstOffer"
      :organization-id="organizationId"
      :title="title"
      :show="modals.firstOffer"
      @toggleDialog="toggleDialog"
      @next="next"
    />

    <CancellationFinalOfferDialog
      id="finalOffer"
      :organization-id="organizationId"
      :title="title"
      :show="modals.finalOffer"
      :is-trial="isTrial"
      :subscription-period="subscriptionPeriod"
      @toggleDialog="toggleDialog"
      @next="next"
    />

    <CancellationFeedbackDialog
      id="feedback"
      :title="title"
      :show="modals.feedback"
      :organization-id="organizationId"
      :eligible="eligibleFlow"
      @toggleDialog="toggleDialog"
      @previous="previous"
    />
  </div>
</template>

<script>
import CancellationReviewDataDialog from './CancellationReviewDataDialog.vue';
import CancellationFirstOfferDialog from './CancellationFirstOfferDialog.vue';
import CancellationFinalOfferDialog from './CancellationFinalOfferDialog.vue';
import CancellationFeedbackDialog from './CancellationFeedbackDialog.vue';

import { InsightsResource } from '~/resources';

export default {
  name: 'CancellationFlow',
  components: {
    CancellationReviewDataDialog,
    CancellationFirstOfferDialog,
    CancellationFinalOfferDialog,
    CancellationFeedbackDialog,
  },
  props: {
    initialState: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    loading: true,
    isEligible: false,
    title: 'Remove Insights add-on',
    modals: {
      reviewData: false,
      firstOffer: false,
      finalOffer: false,
      feedback: false,
    },
    flow: {
      subscription: ['reviewData', 'finalOffer', 'feedback'],
      trial: ['reviewData', 'firstOffer', 'finalOffer', 'feedback'],
      not_eligible: ['feedback'],
    },
  }),
  computed: {
    organizationId() {
      return this.initialState.organization_id;
    },
    isTrial() {
      return this.initialState.active_trial;
    },
    subscriptionPeriod() {
      return this.initialState.subscription_period || '';
    },
    eligibleFlow() {
      return this.isEligible && this.initialState.has_plan;
    },
    currentFlow() {
      return !this.eligibleFlow ? this.flow.not_eligible : this.isTrial ? this.flow.trial : this.flow.subscription;
    },
    currentFlowIndex() {
      return Object.entries(this.flow).findIndex(([key, value]) => value === this.currentFlow);
    },
    currentDialog() {
      return Object.entries(this.modals).find(([key, value]) => value === true)?.[0];
    },
    currentDialogIndex() {
      return this.currentFlow.findIndex((dialog) => dialog === this.currentDialog);
    },
  },
  async mounted() {
    if (!this.initialState.org_suspended) {
      await this.fetchCancellationEligibility();
    }
    this.loading = false;
  },
  methods: {
    openFlow() {
      const modal = this.eligibleFlow ? 'reviewData' : 'feedback';

      this.modals[modal] = true;
    },
    offerTypeForModal(modal) {
      if (modal === 'firstOffer') {
        return 'extend_trial';
      }

      if (modal === 'finalOffer') {
        return this.isTrial ? 'combined_discount_and_trial_extension' : 'apply_discount';
      }

      return null;
    },
    async trackRetentionOffer(offerType) {
      try {
        await InsightsResource.trackRetentionOffer(
          { organizationId: this.organizationId },
          { offer_type: offerType },
        );
      } catch (error) {
        console.error(error);
      }
    },
    async fetchCancellationEligibility() {
      try {
        this.loading = true;
        const params = { organizationId: this.organizationId };
        const response = await InsightsResource.extendedCancellationEligibility(params);

        if (response) {
          this.isEligible = response.eligible;
        }
      } catch (error) {
        this.isEligible = false;
        console.error(error);
      }
    },
    toggleDialog(modal, value, event) {
      this.ctaAnalytics(event);
      this.modals[modal] = value;

      if (value) {
        const offerType = this.offerTypeForModal(modal);

        if (offerType) {
          this.trackRetentionOffer(offerType);
        }
      }
    },
    previous(current, event) {
      this.ctaAnalytics(event);
      this.toggleDialog(this.currentFlow[this.currentDialogIndex - 1], true);
      this.toggleDialog(current, false);
    },
    next(current, event) {
      this.ctaAnalytics(event);
      this.toggleDialog(this.currentFlow[this.currentDialogIndex + 1], true);
      this.toggleDialog(current, false);
    },
    ctaAnalytics(event) {
      if (event) {
        const name = `I cancel flow ${this.currentFlowIndex + 1}d${this.currentDialogIndex + 1}`;

        window.analytics?.track(name, {
          selection: event.target.innerHTML || '',
        });
      }
    },
  },
};
</script>
